import { uuid as uuidv4 } from './browser';
import { TRACKING_COOKIES } from '../constants';
import { readCookie, writeCookie } from './cookies';
import { getUtmTags } from './url';

/**
 * If UTM tags are present in the URL, set them as tracking tags on the player instance.
 * 
 * The standard UTM tags are:
 * utm_id - Campaign ID
 * utm_source - Identifies the website where the traffic is coming from. For example, instagram, facebook, or google.
 * utm_medium - Identifies the type of marketing medium. For example, email, social, or cost-per-click (cpc).
 * utm_campaign - Identifies a specific advertising campaign. For example, bambuser_live
 * utm_content - Helps to differentiate links or ads that point to the same URL from the same source, 
 * medium, and campaign. For example, the live show title
 * utm_term - Identifies the keywords that were paid for in paid keyword campaigns. For example, product sku
 */
const customTagsHandler = (window, document, BambuserLiveShopping) => {
  const { hasUtmTags, utmTags, utmObject } = getUtmTags(window.location.href);

  if (!hasUtmTags) return;
  document.addEventListener('bambuser-instance-ready', (event) => {
    try {
      event.detail.instance.setTrackingTags(utmTags);
    } catch (error) {
      console.error('Error setting tracking tags', error);
    }
  });

  const existingUserId = readCookie(TRACKING_COOKIES.USER_ID);
  const existingSessionId = readCookie(TRACKING_COOKIES.SESSION_ID);
  const userId = existingUserId || uuidv4();
  const sessionId = existingSessionId || uuidv4();

  const cookieConf = {
    expires: 365,
    domain: window.location.hostname,
  };

  if (!existingUserId) {
    writeCookie(TRACKING_COOKIES.USER_ID, userId, cookieConf);
  }

  if (!existingSessionId) {
    writeCookie(TRACKING_COOKIES.SESSION_ID, sessionId, cookieConf);
  }

  // Always track utm tags if present
  BambuserLiveShopping.prototype._trackMetricEmit({
    userId,
    sessionId,
    source: 'embed',
    eventType: 'on-utm-referred',
    insertId: uuidv4(),
    payload: utmObject,
  });
};

export {
  customTagsHandler,
};